import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { Product } from '@/entities/product';

export type FavoriteGuestEntry = Pick<
  Product,
  'id' | 'slug' | 'name' | 'image' | 'subcategory'
>;

interface FavoriteGuestState {
  entries: FavoriteGuestEntry[];
  setEntries: (entries: FavoriteGuestEntry[]) => void;
  upsertFromProduct: (product: Product) => void;
  removeById: (productId: number) => void;
  clear: () => void;
}

function toEntry(product: Product): FavoriteGuestEntry {
  return {
    id: product.id,
    slug: product.slug,
    name: product.name,
    image: product.image,
    subcategory: product.subcategory,
  };
}

export const useFavoriteGuestStore = create<FavoriteGuestState>()(
  persist(
    (set, get) => ({
      entries: [],
      setEntries: (entries) => set({ entries }),
      upsertFromProduct: (product) => {
        const entry = toEntry(product);
        const rest = get().entries.filter((e) => e.id !== entry.id);

        set({ entries: [...rest, entry] });
      },
      removeById: (productId) =>
        set({
          entries: get().entries.filter((e) => e.id !== productId),
        }),
      clear: () => set({ entries: [] }),
    }),
    { name: 'favorite-guest-storage' },
  ),
);
